/** 로비 공지 팝업 — 운영자가 admin에서 발행하는 공지 1건. */
export interface NoticeItem {
  /** dismiss 추적용 안정 식별자 (admin에서 crypto.randomUUID() 생성). */
  id: string;
  /** 표시/내림 토글. */
  active: boolean;
  /** 오름차순 정렬 — 활성 여러 개면 이 순서대로 순차 노출. */
  order: number;
  /** 한글용 이미지(V8 CDN URL). */
  imageUrlKo?: string;
  /** 영어용 이미지(V8 CDN URL). */
  imageUrlEn?: string;
  /** 레거시/공통 폴백 — ko·en 미지정 시 양쪽에 사용. */
  imageUrl?: string;
  /** 외부 URL. 없으면 이미지 클릭 불가. */
  linkUrl?: string;
  /** admin 리스트 가독성용 라벨 — 게임 내 미표시. */
  title?: string;
}

/** 공지 이미지 분기 로케일 — client getLocale()은 항상 이 둘 중 하나. */
export type NoticeLocale = 'ko' | 'en';

/**
 * 로케일별 표시 이미지 해석(순수). 로케일 전용 이미지 우선, 없으면 레거시 공통.
 * cross-locale 폴백 없음 — 결과 undefined면 그 로케일엔 공지를 숨긴다.
 */
export function resolveNoticeImage(notice: NoticeItem, locale: NoticeLocale): string | undefined {
  const localeUrl = locale === 'ko' ? notice.imageUrlKo : notice.imageUrlEn;
  return localeUrl ?? notice.imageUrl;
}

/** 채널별 공지 발행본(R2 standalone JSON). */
export interface NoticeConfig {
  notices: NoticeItem[];
}

/** 미발행/fetch 실패 시 graceful fallback. */
export const EMPTY_NOTICE_CONFIG: NoticeConfig = { notices: [] };
